import { accountLoginAction, accountSignoutAction } from './actionTypes'
import { AuthTokens } from '../../models/auth/authTokens'



export const accountLogin = (data: AuthTokens) => ({ type: accountLoginAction, payload: data })

export const accountSignout = () => ({ type: accountSignoutAction })
